// Shared licence-document file validation.
//
// The 10 MB + MIME-type check used to live as two byte-identical copies
// (AgentDetailsStep.js and AgentAccountInfo.js/LicenseUpdateModal). It is
// extracted here so the agent onboarding step, the agency founding step and
// the "Update License" modal all enforce exactly the same rule with exactly
// the same toast wording. Behaviour is unchanged from the copies it replaces.

import toast from "react-hot-toast";

// 10MB
export const MAX_LICENSE_FILE_SIZE = 10 * 1024 * 1024;

export const ALLOWED_LICENSE_FILE_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/jpeg",
  "image/jpg",
  "image/png",
];

// Keep in sync with ALLOWED_LICENSE_FILE_TYPES — used as the file input's
// `accept` attribute.
export const LICENSE_FILE_ACCEPT = ".pdf,.doc,.docx,.jpg,.jpeg,.png";

/**
 * Validate the file picked by a file <input> change event.
 *
 * On failure the same toast as before is shown and the input is reset, so the
 * user can pick again. Returns the File when valid, otherwise null (callers
 * simply keep their previous state, exactly like the original copies did).
 */
export const pickValidLicenseFile = (event) => {
  const file = event?.target?.files?.[0];
  if (!file) return null;

  if (file.size > MAX_LICENSE_FILE_SIZE) {
    toast.error("File size must be less than 10MB");
    if (event.target) event.target.value = "";
    return null;
  }

  if (!ALLOWED_LICENSE_FILE_TYPES.includes(file.type)) {
    toast.error("Please select a valid file type (PDF, DOC, DOCX, JPG, PNG)");
    if (event.target) event.target.value = "";
    return null;
  }

  return file;
};

export default pickValidLicenseFile;
